import React from "react";
import { MDBFooter, MDBContainer, MDBCol, MDBRow } from "mdb-react-ui-kit";

export default function App() {
  return (
    <MDBFooter
      className="text-center text-white"
      style={{ backgroundColor: "#f6b836",marginTop:"100px", width:"90%",margin:"auto" }}
    >
      <MDBContainer className="p-4">
        <section className="">
          <div className="row d-flex justify-content-center">
            <MDBCol lg="6">
              <div className="ratio ratio-16x9">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/ZguNi_AYk_c"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </MDBCol>
          </div>
        </section>
      </MDBContainer>

      <div
        className="text-center p-3"
        style={{ backgroundColor: "#f7665e" }}
      >
        © 2022 Copyright:
        <a className="text-white" href="https://mdbootstrap.com/">
          Temmplebooking.com
        </a>
      </div>
    </MDBFooter>
  );
}
